<template>
  <v-card class="bid-form" variant="outlined">
    <bid-view-currency />
    <bid-view-description :is-disabled-form="isDisabledForm" class="my-7" />
    <bid-view-phases :is-disabled-form="isDisabledForm" class="mt-6" />
    <bid-view-questions :is-disabled-form="isDisabledForm" />
  </v-card>
</template>

<script setup lang="ts">
import BidViewCurrency from '@/components/BidView/BidViewCurrency.vue';
import BidViewPhases from '@/components/BidView/BidViewPhases.vue';
import BidViewDescription from '@/components/BidView/BidViewDescription.vue';
import BidViewQuestions from '@/components/BidView/BidViewQuestions.vue';
import { withDefaults, defineProps } from 'vue';

// #interfaces
interface IProps {
  isDisabledForm: boolean;
}

// #props
withDefaults(defineProps<IProps>(), {
  isDisabledForm: false
});
</script>

<style scoped lang="scss">
@import '@/assets/style/colors';
.bid-form {
  padding: 36px 36px 67px 36px;
  background: $color-ui-white !important;
  &__payment-currency {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
}
</style>
